export const defaultFields = [
    'Наименование страхователя',
    'Номер договора',
    'Начало действия',
    'Окончание действия',
    'Количество застрахованных',
    'Страхования премия',
];
export const allFields = [
    'Наименование страхователя',
    'Номер договора',
    'Начало действия',
    'Окончание действия',
    'Количество застрахованных',
    'Страхования премия',
    'Дата рождения',
    'Телефон',
    'Почта',
    'Статус оплаты',
    'Дата платежа',
    'Дата заключения',
    'Вид страхования',
    'Наименование программы',
    'Источник продажи'
];
export const fieldMappings: Record<string, string> = {
    'Наименование страхователя': 'InsurerName',
    'Номер договора': 'Number',
    'Начало действия': 'StartDate',
    'Окончание действия': 'EndDate',
    'Количество застрахованных': 'InsuredQuantity',
    'Страхования премия': 'InsurancePremium',
    'Дата рождения': 'InsurerBirthDate',
    'Телефон': 'InsurerPhone',
    'Почта': 'InsurerEmail',
    'Статус оплаты': 'PaymentStatusName',
    'Дата платежа': 'PaymentDate',
    'Дата заключения': 'ConclusionDate',
    'Вид страхования': 'ProductName',
    'Наименование программы': 'InsuranceProgramPrintName',
    'Источник продажи': 'AgentSaleSourceName',
};